// 组件对象，大写
import partitionErect from './partitionErect.vue'
export default partitionErect
